export { TheatricalPayItForwardView } from './TheatricalPayItForwardView'
